import React, { forwardRef } from 'react';
import {
  NumberInput as ChakraNumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  NumberInputProps,
  NumberInputFieldProps,
  useStyleConfig,
} from '@chakra-ui/react';

interface Props extends Omit<NumberInputProps, `css`> {
  inputProps?: NumberInputFieldProps;
  placeholder?: string;
}

export const NumberInput = forwardRef<HTMLInputElement, Props>(
  ({ inputProps, ...props }, ref): JSX.Element => {
    const styles = useStyleConfig(`NumberInput`);

    return (
      <ChakraNumberInput {...props}>
        <NumberInputField
          __css={styles}
          placeholder={props.placeholder}
          ref={ref}
          {...inputProps}
        />
        <NumberInputStepper>
          <NumberIncrementStepper />
          <NumberDecrementStepper />
        </NumberInputStepper>
      </ChakraNumberInput>
    );
  }
);
export type { Props as NumberInputProps };
